export const TuscanPattern = (color) => {
  return `
        <svg xmlns="http://www.w3.org/2000/svg" width="402" height="180" viewBox="0 0 402 180" fill="none">
<g filter="url(#filter0_d_110_539)">
<rect x="1" width="400" height="45.1576" fill="${color}"/>
</g>
<line y1="-0.5" x2="400.001" y2="-0.5" transform="matrix(0.999997 -0.00250875 0.00249127 0.999997 1 13.0455)" stroke="white" stroke-opacity="0.3"/>
<line y1="-0.5" x2="400.001" y2="-0.5" transform="matrix(0.999997 -0.00250875 0.00249127 0.999997 1 32.112)" stroke="white" stroke-opacity="0.3"/>
<g filter="url(#filter1_d_110_539)">
<rect x="1" y="87.9544" width="400" height="45.1576" fill="${color}"/>
</g>
<line y1="-0.5" x2="400.001" y2="-0.5" transform="matrix(0.999997 -0.00250875 0.00249127 0.999997 1 101)" stroke="white" stroke-opacity="0.3"/>
<line y1="-0.5" x2="400.001" y2="-0.5" transform="matrix(0.999997 -0.00250875 0.00249127 0.999997 1 120.066)" stroke="white" stroke-opacity="0.3"/>
<g filter="url(#filter2_d_110_539)">
<rect width="400" height="45.1576" transform="matrix(-1 0 0 1 401 45.0228)" fill="${color}"/>
</g>
<line y1="-0.5" x2="400.001" y2="-0.5" transform="matrix(-0.999997 -0.00250875 -0.00249127 0.999997 401 58.0683)" stroke="white" stroke-opacity="0.3"/>
<line y1="-0.5" x2="400.001" y2="-0.5" transform="matrix(-0.999997 -0.00250875 -0.00249127 0.999997 401 77.1348)" stroke="white" stroke-opacity="0.3"/>
<g filter="url(#filter3_d_110_539)">
<rect width="400" height="45.1576" transform="matrix(-1 0 0 1 401 132.835)" fill="${color}"/>
</g>
<line y1="-0.5" x2="400.001" y2="-0.5" transform="matrix(-0.999997 -0.00250875 -0.00249127 0.999997 401 145.881)" stroke="white" stroke-opacity="0.3"/>
<line y1="-0.5" x2="400.001" y2="-0.5" transform="matrix(-0.999997 -0.00250875 -0.00249127 0.999997 401 164.947)" stroke="white" stroke-opacity="0.3"/>
<defs>
<filter id="filter0_d_110_539" x="0" y="0" width="402" height="47.1576" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_110_539"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_110_539" result="shape"/>
</filter>
<filter id="filter1_d_110_539" x="0" y="87.9544" width="402" height="47.1576" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_110_539"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_110_539" result="shape"/>
</filter>
<filter id="filter2_d_110_539" x="0" y="45.0228" width="402" height="47.1576" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_110_539"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_110_539" result="shape"/>
</filter>
<filter id="filter3_d_110_539" x="0" y="132.835" width="402" height="47.1576" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_110_539"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_110_539" result="shape"/>
</filter>
</defs>
</svg>
        `;
};
